<div class="toast toast-end">
  @for (toast of toasts; track toast.id) {
    <app-toast [toast]="toast"></app-toast>
  }
</div>
